// extracted by mini-css-extract-plugin
module.exports = {"daily_gems_page":"DailyGems_daily_gems_page__3WJnh","loading_screen":"DailyGems_loading_screen__2jSm_","loading_text":"DailyGems_loading_text__2Wx8F"};